<template>
	<div class="app-container">
	  <!-- 顶部标题栏 -->
	  <div class="header-bar">
		<button @click="goBack" class="back-btn"><i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow" style="font-size: 10px !important;"></i></button>
		<div class="title-center">
		  <div class="subtitle">{{ $t('certification.myCertRecords') }}</div>
		  <div class="main-title">{{ $t('certification.totalRecords', { count: recordList.length }) }}</div>
		</div>
	  </div>
  
	  <!-- 背景图（模糊） -->
	  <div class="bg-image"></div>
  
	  <!-- 记录列表区域 -->
	  <div class="record-list-wrapper">
		<div v-for="(item, index) in recordList" :key="index" class="record-card">
		  <div class="record-header">
			<div class="record-type">{{ item.type || $t('certification.carCert') }}</div>
			<div class="record-status" :class="item.status === 1 ? 'approved' : 'pending'">
			  <div class="status-icon">
				<span v-if="item.status === 1">✓</span>
				<span v-else>⏰</span>
			  </div>
			  <span class="status-text">{{ item.status === 1 ? $t('certification.approved') : $t('certification.pendingReview') }}</span>
			</div>
		  </div>
		  <div class="record-content">
			<div class="record-item">
			  <span class="label">{{ $t('certification.items') }}:</span>
			  <span class="value">{{ item.items || $t('certification.none') }}</span>
			</div>
			<div class="record-item-inline">
			  <div class="record-item">
				<span class="label">{{ $t('certification.orderNo') }}:</span>
				<span class="value">{{ item.expect || item.order_no || '-' }}</span>
			  </div>
			  <div class="record-item">
				<span class="label">{{ $t('certification.pointsConsumed') }}:</span>
				<span class="value">{{ item.money || item.points || 0 }}</span>
			  </div>
			</div>
			<hr style="border: 1px solid rgba(255, 255, 255, 0.1);margin-top:10px;">
			<div class="record-item-inline">
			  <div class="record-item">
				<span class="label">{{ $t('certification.applyTime') }}:</span>
				<span class="value">{{ item.create_time || item.apply_time || '-' }}</span>
			  </div>
			  <div v-if="item.status === 1 && item.update_time" class="record-item">
				<span class="label">{{ $t('certification.reviewTime') }}:</span>
				<span class="value">{{ item.update_time || item.audit_time || '-' }}</span>
			  </div>
			</div>
		  </div>
		</div>
		
		<div v-if="recordList.length === 0" class="empty-state">
		  <div class="empty-text">{{ $t('certification.noRecords') }}</div>
		</div>
	  </div>
  
	  <!-- 底部导航栏 -->
	  <!-- <div class="footer-nav">
		<button v-for="tab in tabs" :key="tab.name" @click="switchTab(tab.name)" class="nav-item" :class="{ active: activeTab === tab.name }">
		  <div class="nav-icon">{{ tab.icon }}</div>
		  <div class="nav-text">{{ tab.text }}</div>
		</button>
	  </div> -->
	</div>
  </template>
  
  <script>
  export default {
	name: 'CertificationRecord',
	data() {
	  return {
		recordList: [],
		activeTab: '',
		tabs: []
	  }
	},
	mounted() {
	  // 初始化tabs
	  this.tabs = [
		{ name: 'info', icon: 'ℹ️', text: this.$t('common.info') || '信息' },
		{ name: 'video', icon: '▶️', text: this.$t('common.video') || '视频' },
		{ name: 'square', icon: '❤️', text: this.$t('common.square') || '广场' },
		{ name: 'auth', icon: '⭐', text: this.$t('common.auth') || '认证' },
		{ name: 'my', icon: '', text: this.$t('common.my') || '我的' }
	  ]
	  this.getRecordList()
	},
	methods: {
	  goBack() {
		return window.history.back();
	  },
	  switchTab(tabName) {
		this.activeTab = tabName
		// 可以添加跳转逻辑
		if (tabName === 'auth') {
		  this.$router.push({ path: '/Certification' })
		}
	  },
	  getRecordList() {
		if (!localStorage.getItem('token')) {
		  this.$router.push({ path: '/Login' })
		  return
		}
		
		// 从路由参数获取 lottery_id
		const lottery_id = this.$route.query.lottery_id || 'all'
		
		// 获取游戏记录（下注记录）
		this.$http({
		  method: 'get',
		  data: { page: 1, limit: 100, status: 0, lottery_id: lottery_id },
		  url: 'user_get_game_list'
		}).then(res => {
		  if (res.code === 200) {
			// 转换数据格式以匹配显示需求
			this.recordList = (res.data || []).map(item => {
			  // 根据下注类型判断认证类型
			  let type = this.$t('certification.carCert')
			  let items = ''
			  
			  // 解析下注项，转换为物品名称
			  if (item.data && Array.isArray(item.data)) {
				const itemNames = item.data.map(d => {
				  // 根据类型映射到商品名称（使用原始中文键匹配）
				  const typeMap = {
					'大': this.$t('certification.product1'),
					'小': this.$t('certification.product2'),
					'单': this.$t('certification.product3'),
					'双': this.$t('certification.product4')
				  }
				  return typeMap[d.type] || d.type
				})
				items = itemNames.join('、')
			  }
			  
			  // 根据状态判断认证类型（这里可以根据实际业务逻辑调整）
			  if (item.status === 1) {
				type = this.$t('certification.hotelCert')
			  }
			  
			  return {
				type: type,
				status: item.status || 0, // 0: 待审核, 1: 已通过
				items: items || this.$t('certification.none'),
				expect: item.expect || '',
				order_no: item.expect || '',
				money: item.money || 0,
				points: item.money || 0,
				create_time: item.create_time || '',
				apply_time: item.create_time || '',
				update_time: item.update_time || '',
				audit_time: item.update_time || ''
			  }
			})
		  } else if (res.code === 401) {
			this.$toast.fail(res.msg || this.$t('certification.getRecordsFailed'))
		  }
		}).catch(() => {
		  this.$toast.fail(this.$t('certification.getRecordsFailedRetry'))
		})
	  }
	}
  }
  </script>
  
  <style scoped>
  .app-container {
	position: relative;
	height: 100vh;
	background: #000;
	color: white;
	overflow: hidden;
	font-family: Arial, sans-serif;
  }
  
  /* 顶部标题栏 */
  .header-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 25px 16px;
	background:url(/img/header.svg) no-repeat 50%/100%;;
	position: relative;
	z-index: 10;
	height: 3rem;
  }
  
  .back-btn {
	font-size: 28px;
	background: none;
	border: none;
	color: white;
	cursor: pointer;
  }
  
  .title-center {
	text-align: center;
	flex: 1;
	margin-left: -10%;
  }
  
  .subtitle {
	font-size: 30px;
	opacity: 0.8;
  }
  
  .main-title {
	font-size: 22px;
	font-weight: bold;
  }
  
  /* 背景图 */
  .bg-image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: url('http://www.desire-club.top/xuanfei/20241022/7bf5bf8a20b306cf1706f8d9eab4b76c.jpg') no-repeat center center;
	background-size: cover;
	filter: blur(2px);
	opacity: 0.4;
	z-index: 0;
  }
  
  /* 记录列表区域 */
  .record-list-wrapper {
	position: relative;
	z-index: 5;
	padding: 20px 16px;
	padding-bottom: 100px;
	max-height: calc(100vh - 140px);
	overflow-y: auto;
  }
  
  .record-card {
	background: rgba(0, 0, 0, 0.7);
	border-radius: 16px;
	padding: 30px;
	margin-bottom: 20px;
	border: 2px solid rgba(236, 72, 153, 0.3);
  }
  
  .record-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	padding-bottom: 16px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .record-type {
	font-size: 28px;
	font-weight: bold;
	color: #ffffff;
  }
  
  .record-status {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 28px;
  }
  
  .status-icon {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	font-weight: bold;
  }
  
  .record-status.pending .status-icon {
	background: #ff4444;
	color: white;
  }
  
  .record-status.approved .status-icon {
	background: #00ff88;
	color: white;
  }
  
  .status-text {
	font-size: 20px;
	font-weight: 500;
  }
  
  .record-content {
	display: flex;
	flex-direction: column;
	gap: 10px;
  }
  
  .record-item {
	display: flex;
	align-items: flex-start;
	font-size: 22px;
	line-height: 1.5;
	margin-top:15px;
  }
  
  .record-item .label {
	color: rgba(255, 255, 255, 0.7);
	margin-right: 8px;
	min-width: 80px;
	text-align: left;
  }
  
  .record-item .value {
	color: white;
	flex: 1;
	text-align: left;
  }
  
  .record-item-inline {
	display: flex;
	align-items: flex-start;
	gap: 16px;
	flex-wrap: wrap;
  }
  
  .record-item-inline .record-item {
	flex: 1;
	min-width: 0;
  }
  
  .record-item-inline .record-item .label {
	min-width: auto;
  }
  
  .empty-state {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 60px 20px;
  }
  
  .empty-text {
	font-size: 18px;
	color: rgba(255, 255, 255, 0.5);
  }
  
  /* 底部导航栏 */
  .footer-nav {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: none;
	border-top: 2px solid #ec4899;
	display: flex;
	justify-content: space-around;
	padding: 8px 0;
	z-index: 100;
  }
  
  .nav-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0;
	font-size: 20px;
	color: #fff;
	cursor: pointer;
	transition: color 0.2s;
	background: none;
    border: none;
  }
  
  .nav-item.active {
	color: #ec4899;
  }
  
  .nav-icon {
	font-size: 28px;
	margin-bottom: 6px;
  }
  
  .nav-text {
	font-size: 28px;
  }
  </style>
